module.exports = __webpack_public_path__ + "static/media/unFavButtonIcon.1afa9498.svg";